import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

async function getSWRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  return await navigator.serviceWorker.getRegistration("/service-worker.js")
    || await navigator.serviceWorker.register("/service-worker.js");
}

export async function getCurrentSubscription() {
  const reg = await getSWRegistration();
  if (!reg) return null;
  return await reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push is not supported in this browser.");
  const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission was not granted.");
  const reg = await getSWRegistration();
  if (!reg) throw new Error("Service worker unavailable.");
  const { data } = await api.get("/push/public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  }
  const raw = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys,
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getCurrentSubscription();
  if (!sub) return true;
  try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch { /* noop */ }
  return await sub.unsubscribe();
}

export async function sendTestPush() {
  await api.post("/push/test");
}
